import React from 'react';

interface YoutubeVideoProps {
  youtubeId: string;
}

const YoutubeVideo: React.FC<YoutubeVideoProps> = ({ youtubeId }) => {
  if (!youtubeId) return null;
  return (
    <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%', height: 0, margin: '24px 0' }}>
      <iframe
        src={`https://www.youtube.com/embed/${youtubeId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: '#000',
        }}
      />
    </div>
  );
};

export default YoutubeVideo;
